(() => {
  const images = new Map();
  window.EptProof = {
    logo(url) {
      if (!images.has(url)) images.set(url, new Promise((resolve, reject) => {
        const image = new Image(); image.crossOrigin = 'anonymous';
        image.onload = () => resolve(image); image.onerror = reject; image.src = url;
      }));
      return images.get(url);
    },
    mark(canvas, logo) {
      const ctx = canvas.getContext('2d');
      ctx.save(); ctx.setTransform(1,0,0,1,0,0);
      const step = canvas.width / 2.5;
      ctx.globalAlpha = 0.32;
      for (let row = -1; row < canvas.height / step + 2; row++) {
        for (let col = -1; col < 4; col++) {
          ctx.save(); ctx.translate((col + (row % 2) * .5) * step, row * step * .8);
          ctx.rotate(-Math.PI / 7);
          const size = step * .32;
          ctx.drawImage(logo, -size / 2, -size, size, size * logo.naturalHeight / logo.naturalWidth);
          ctx.fillStyle = '#173d72'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
          ctx.font = `700 ${step * .066}px Arial, sans-serif`;
          ctx.fillText('EGGEN PRESS TRADING', 0, size * .35);
          ctx.font = `700 ${step * .052}px Arial, sans-serif`;
          ctx.fillText('KORREKTUR – IKKE TIL TRYKK', 0, size * .65);
          ctx.restore();
        }
      }
      ctx.restore();
    }
  };
})();
